import { Service, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AvatarUploadResponse {
  avatarId: string;
  userId: string;
}

@Service()
export class AvatarApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.api.baseUrl}/avatars`;

  getAvatarUrl(userId: string): string {
    return `${this.baseUrl}/${userId}`;
  }

  uploadMyAvatar(file: File): Observable<AvatarUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<AvatarUploadResponse>(`${this.baseUrl}/me`, formData);
  }

  deleteMyAvatar(): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/me`);
  }
}
